import { DefaultPageConfigurationType } from '../../../api/custom-pages.dao';
import { DefaultPageEntity } from './default-page.entity';


export class DefaultPageMapper {
    static toEntity(props: DefaultPageConfigurationType): DefaultPageEntity {
        return DefaultPageEntity.create(props);
    }

    static toDTO(entity: DefaultPageEntity): DefaultPageConfigurationType {
        return entity.toDTO();
    }
}
